import React from 'react';
import styles from '../css/comuns/Ofertaschips.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWifi, faPhone, faCommentAlt, faUsers, faGraduationCap, faBriefcase, faGamepad, faTachometerAlt, faInfinity, faGlobe } from '@fortawesome/free-solid-svg-icons';
import { config } from '../../data';

// Mapeamento dos ícones
const iconMap = {
  faWifi, faPhone, faCommentAlt, faUsers, faGraduationCap,
  faBriefcase, faGamepad, faTachometerAlt, faInfinity, faGlobe
};

// Mapeamento das imagens disponíveis
const getImagesByCount = (count) => {
  const imgs = [
    config.images.ofertasChips.img1,
    config.images.ofertasChips.img2,
    config.images.ofertasChips.img3,
    config.images.ofertasChips.img4,
  ];
  
  if (count === 1) return [imgs[0]];
  if (count === 2) return [imgs[1], imgs[2]];
  if (count === 3) return [imgs[1], imgs[2], imgs[3]];
  return [imgs[3], imgs[0], imgs[1]];
};

const Ofertaschips = () => {
  // Converte os planos do config para o formato esperado
  const planos = config.content.ofertasChips.map(plano => ({
    ...plano,
    features: plano.features.map(f => ({ ...f, icon: iconMap[f.icon] })),
    imagens: getImagesByCount(plano.imagensCount),
  }));

  return (
    <div className={styles['ofertas-container']}>
      <h2 className={styles.title}>Planos Exclusivos Oni Telecom</h2>
      <p className={styles.slogan}>Conectando seu mundo, superando limites. Oni Telecom: Sua jornada, nossa missão.</p>
      <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4">
        {planos.map((plano, index) => (
          <div className="col" key={index}>
            <div className={styles.cardschip}>
              {plano.destaque && <div className={styles.destaque}>{plano.destaque}</div>}
              <div>
                <h3>{plano.nome}</h3>
                <div className={styles['cardschip-content']}>
                  {plano.features.map((feature, fIndex) => (
                    <p key={fIndex}>
                      <FontAwesomeIcon icon={feature.icon} /> {feature.text}
                    </p>
                  ))}
                  <p className={styles.preco}>{plano.preco}</p>
                </div>
              </div>
              <div className={styles['image-container']}>
                {plano.imagens.map((img, imgIndex) => (
                  <div className={styles['streamer-offer']} key={imgIndex}>
                    <img src={img} alt={`Oferta Streamer ${index * 10 + imgIndex + 1}`} />
                  </div>
                ))}
              </div>
              <button className={styles['contratar-btn']}>Contratar</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Ofertaschips;